import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

interface showMoreText {
  loadingText: string;
  showMoreText: string;
}

@Component({
  standalone: true,
  imports: [],
  selector: 'app-show-more',
  templateUrl: './show-more.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./show-more.component.scss'],
})
export class ShowMoreComponent {
  isLoading = input(false);
  isShowMore = input(true);
  text = input<showMoreText>({
    loadingText: 'Loading...',
    showMoreText: 'Show more',
  });
  loadMore = output<void>();

  onClick(): void {
    if (!this.isLoading()) {
      this.loadMore.emit();
    }
  }
}
